<div class="page">
    <div class="page-body" *ngIf="response.status == 1">
        <div class="page-title" *ngIf="page.mostrar_titulo">
            <div class="container">
                <h1 class="wow slideInDown">{{page.titulo}}</h1>
                <h2 *ngIf="page.mostrar_subtitulo">{{page.subtitulo}}</h2>
            </div>    
        </div>
        <div class="page-content">
            <section class="section section-descricao wow fadeIn">
                <div class="container"> 
                    <article class="descricao" [innerHtml]="page.texto | safeHtml"></article> 
                </div>    
            </section>
            <section class="section section-visao paralax" [ngStyle]="{'background-image': 'url(' + photo + ')'}" *ngIf="params.texto_visao_ativo">
                <div class="container"> 
                    <h3>
                        Visão
                    </h3>
                    <article class="descricao" [innerHtml]="params.texto_visao | safeHtml"></article> 
                </div>    
            </section>
            <modulo posicao="chamada"></modulo> 
            <section class="section section-valores">
                <div class="section-title">
                    <div class="container">
                        <h3>Nossos Valores</h3>
                    </div>
                </div>    
                <div class="section-content">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-3" *ngFor="let v of valores">
                                <valor-item [data]="v"></valor-item>
                            </div>    
                        </div>    
                    </div>
               </div>
            </section>
        </div>
    </div>
    <div class="page-body" *ngIf="response.status == 500">
        <page-error (reload)="getData()"></page-error>   
    </div>    
</div>        
<loader [hidden]="!loader" message="Carregando. Aguarde!"></loader> 